import { render, staticRenderFns } from "./serial-only.vue?vue&type=template&id=b8db02ca&scoped=true&"
import script from "./serial-only.vue?vue&type=script&lang=js&"
export * from "./serial-only.vue?vue&type=script&lang=js&"
import style0 from "./serial-only.vue?vue&type=style&index=0&id=b8db02ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8db02ca",
  null
  
)

export default component.exports